import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetActiveMeetingsPayload {
  meetingId: string;
}

export default function useGetActiveMeetingsApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetActiveMeetingsPayload> {
  return useMutation<any, unknown, GetActiveMeetingsPayload>(
    async (payload: GetActiveMeetingsPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_active_meetings_info/',
        payload,
      );
      console.log('Retrieved get_active_meetings_info = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch get_active_meetings_info:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
